import "./NotFound.scss";
import { ArrowLeft, Compass, Home, MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { discordUrl } from "../../Global";

export default function NotFound() {
    const { t } = useTranslation();

    return (
        <section className="not-found">
            {/* ===== HERO ===== */}
            <div className="not-found__container">
                <div className="not-found__content">
                    <span className="not-found__badge">
                        {t("notFound.badge", "Errore 404")}
                    </span>

                    <h1 className="not-found__title">
                        {t("notFound.title.up", "Questa pagina")}
                        <br />
                        {t("notFound.title.down", "non ")}
                        <span>{t("notFound.title.bold", "esiste")}</span>
                    </h1>

                    <p className="not-found__description">
                        {t(
                            "notFound.subtitle",
                            "La pagina che stai cercando potrebbe essere stata rimossa, rinominata o non è mai esistita. Prova a tornare alla home o esplorare il nostro network."
                        )}
                    </p>

                    <div className="not-found__actions">
                        <a href="/" className="not-found__button">
                            <Home size={18} />
                            {t("notFound.backHome", "Torna alla home")}
                        </a>
                        <a
                            href={discordUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="not-found__button not-found__button--secondary"
                        >
                            <MessageCircle size={18} />
                            {t("notFound.contact", "Contattaci")}
                        </a>
                    </div>
                </div>

                {/* ===== VISUAL 404 ===== */}
                <div className="not-found__visual">
                    <div className="not-found__glow" />
                    <div className="not-found__number">
                        <span>4</span>
                        <div className="not-found__zero">
                            <Compass />
                        </div>
                        <span>4</span>
                    </div>
                </div>
            </div>

            {/* ===== HINT ===== */}
            <div className="not-found__footer">
                <div className="not-found__footer-container">
                    <a href="javascript:history.back()" className="not-found__hint">
                        <ArrowLeft size={16} />
                        <span>
                            {t("notFound.hint", "Oppure torna alla pagina precedente")}
                        </span>
                    </a>
                </div>
            </div>
        </section>
    );
}